import {ADVERTISERS_FAILED, RECEIVE_ADVERTISERS, REQUEST_ADVERTISERS} from "../actions/types";

function advertisersRequest(state = {}, action) {
  switch (action.type) {
    case RECEIVE_ADVERTISERS:
      return Object.assign({}, state, {
        isFetching: false,
        advertisers: action.payload,
        error: null
      });
    case REQUEST_ADVERTISERS:
      return Object.assign({}, state, {
        isFetching: true,
        advertisers: {},
        error: null
      });
    case ADVERTISERS_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        advertisers: null,
        error: action.error
      });
    default: {
      return state;
    }
  }
}

export default advertisersRequest;
